import React from "react";
//import { connect } from "react-redux";
//import PropTypes from 'prop-types';
import {Redirect } from "react-router-dom";
import RoutePortalLoggedIn from "./RoutePortalLoggedIn";
import EstimatesWrapper from '../../components/estimates/estimatesWrapper';
//import EstimateDetails from '../components/estimates/estimateDetails';

const getQSVAl = (qs, param) => {
    let val = "";
    let reg = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
    if (qs.indexOf(param) != -1) {
        val = reg.exec(qs)[1];
        //console.info(qs);
    }
    return val;
}

/* eslint-disable react/prop-types */
class RoutesPortalEstimates extends React.Component  {


    constructor(props, context) {
        super(props, context);
    }
    render() {
        console.info(`RoutesPortalEstimate props`, this.props);
        const { pathname, search } = this.props.location;
        const csn = getQSVAl(search, "CSN");
        const redirectEstimate = (pathname.indexOf("/estimate/") === 0 && csn.length > 0);
        if (redirectEstimate) {
            return <Redirect from="/estimate/" to={`/estimates/estimateDetails/${csn}`} />;
        } else {// path={["/estimate", "/estimates/:page/:id?"]} component={EstimatesWrapper} title="Estimates"
            return <RoutePortalLoggedIn exact path="/estimates/:page/:id?" location={ this.props.location} component={EstimatesWrapper} title = "Estimates" />;
        }
    }
}
/* eslint-enable react/prop-types */
//const RoutesPortalEstimates = (prps) => {
//    console.info(`RoutesPortalEstimates props`, props);
//    //const { location } = props.props;
//    //const { pathname, search } = location;
//    //const csn = getQSVAl(search, "CSN");
//    //const redirectEstimate = (pathname.indexOf("/estimate/") === 0 && csn.length > 0);
//    {/*<!--RoutePortalLoggedIn path="/estimates" component={Estimates} title="Estimates" /-->*/ }
//    {/*Pricing Transparency*/ }
//    {/*window.serverData.data.enablePricingTransparency && */ }
//    return <React.Fragment>
//            {redirectEstimate && <Redirect to={`/estimates/estimateDetails/${csn}`} /> }
//            <RoutePortalLoggedIn exact path="/estimates/:page/:id?" component={EstimatesWrapper} title="Estimates" />
//        {/*<!--RoutePortalLoggedIn path="/estimate/:page" component={EstimatesWrapper} title="Estimates" /-->*/}

//        </React.Fragment>;
//}
//RoutesPortalEstimates.propTypes = {
//    location: {
//        pathname: PropTypes.string,
//        search: PropTypes.string
//    }
//}

export default RoutesPortalEstimates;